import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
    Datagrid,
    DateField,
    TextField,
    Responsive,
    SimpleList, Button, List,
} from 'react-admin';
import { Box } from '@material-ui/core';
import { formatEnCaRange } from '../../utils';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(theme => ({
    list: {
        marginTop: '1rem',
        marginBottom: '10rem',
    },
    linkToReviewButton: {
        textAlign: 'center'
    }
}))

const AnswersTable = ({ range, selectedMetric, selectedServiceType, selectedQuestion }) => {
    const classes = useStyles()

    const getFilters = () => {
        const dateFilter = formatEnCaRange(range)

        const filters = {
            metric_id: selectedMetric,
            service_type_id: selectedServiceType,
            to: dateFilter.to,
            from: dateFilter.from,
            ...(selectedQuestion && { question_id: selectedQuestion }),
        }

        return { ...filters }
    }

    const CustomButton = ({ record }) => {
        if (record) {
            const { review_type, review_id } = record
            const type = review_type === 'first_impression' ? '/first-impressions/' : '/reviews/'
            const pageType = review_type === 'first_impression' ? '/show' : ''
            const label =
                review_type === 'first_impression' ? 'SEE FIRST IMPRESSION' : 'SEE FULL REVIEW'
            const buttonHref = type + review_id + pageType
            return <Button color="secondary" label={label} href={buttonHref} className={classes.linkToReviewButton}/>
        }

        return null
    }

    return (
        <Box className={classes.list}>
            <List
                basePath="elevation/questions/answers-to-qualifying-questions"
                resource="elevation/questions/answers-to-qualifying-questions"
                filter={getFilters()}
                sort={{field:'review_date', order: 'DESC'}}
                bulkActionButtons={false}
                actions={false}
                empty={
                    <Typography variant="subtitle1" color="textSecondary">
                        No data was found. Try adjusting your filters.
                    </Typography>
                }
            >
                <Responsive
                    small={
                        <SimpleList
                            primaryText={record => record.customer_name}
                            secondaryText={record => record.answer_text}
                        />
                    }
                    medium={
                        <Datagrid>
                            <DateField label="Review date" source="review_date" />
                            <TextField label="Client" source="customer_full_name_to_display" sortBy="customer_name" />
                            <TextField label="Question" source="question_label" sortBy="label_template" />
                            <TextField label="Answer" source="answer_text" />
                            <CustomButton />
                        </Datagrid>
                    }
                />
            </List>
        </Box>
    );
};

export default AnswersTable;
